import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DMSSyncFailedlogService } from '../../business-services/dms-sync-failed-log.service';
import { TranslateService } from '@ngx-translate/core';
import { ModuleNames } from 'projects/Autofacets-Core/src/app/utils/enums';
@Component({
  selector: 'app-exception-view',
  templateUrl: './exception-view.component.html',
  styleUrls: []
})
export class ExceptionViewComponent implements OnInit {

  _clientName: string;
  isMg: boolean = false;

  @Input() dmsLogList;
  @Input() modelHeader;
  @Input() integrationWithDMS;
  environment: any;
  logList: any;

  constructor(public activeModal: NgbActiveModal,
    private dmsFailedLogService: DMSSyncFailedlogService,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this._clientName = localStorage.getItem("Theme");
    this.isMg = this._clientName === 'mg';
    this.environment = this.dmsLogList.environment;
    this.logList = this.dmsLogList;
  }

  onSyncToDms(moduleId, id, name) {
    this.dmsFailedLogService.onSyncToDms(moduleId, id, name, this.dmsLogList, this.environment);
  }


  getSyncLabel(moduleId: number): string {
    if (!this.isMg) {
      return this.translate.instant("lblDMS");
    }

    switch (moduleId) {
      case ModuleNames.Customer:
      case ModuleNames.Vehicle:
        return 'CRM';
      case ModuleNames.DealerDetails:
      case ModuleNames.Mechanic:
        return 'OLB';
      case ModuleNames.Appointment:
        return this.translate.instant("lblDMS");
      default:
        return this.translate.instant("lblDMS");
    }
  }
}
